export { default } from './ThemeSwitcher';


// WEBPACK FOOTER //
// ./src/components/ThemeSwitcher/index.js